import { Divider, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import InlineLabeledTextField from '@/components/dataDisplay/InlineLabeledTextField'
import { formatCapacityMW, formatEnergy, formatRevenue } from '@/features/site/utils/revenueUtils/formatRevenueData'

type RevenuesMonthlySummaryProps = {
  soldCapacity: number
  activatedEnergy: number
  revenue: number
  currency: string
}

export const RevenueMonthlySummary = ({
  soldCapacity,
  activatedEnergy,
  revenue,
  currency,
}: RevenuesMonthlySummaryProps) => {
  const { t } = useTranslation()

  return (
    <Stack direction="row" divider={<Divider flexItem orientation="vertical" />} gap={2}>
      <InlineLabeledTextField
        label={t('site_revenue.sold_capacity')}
        text={formatCapacityMW(t, soldCapacity)}
        width="30%"
      />
      <InlineLabeledTextField
        label={t('site_revenue.activated_energy')}
        text={formatEnergy(t, activatedEnergy)}
        width="30%"
      />
      <InlineLabeledTextField
        label={t('customer_revenue.revenue.label')}
        text={formatRevenue(revenue, currency)}
        width="30%"
      />
    </Stack>
  )
}
